import React from 'react';
import { CourseCardLabelLinks, TRAINING_VIEW_LABELS } from '../../../../lib/constants/labelKeys';
import { Role, useRole } from '../../../../lib/context/SessionContext';
import { Api } from '../../../../lib/types/apiSpec';
import { Label, LabelProps } from '../../../common/Label/Label';

export type LearningDetailsLabelProps = {
  status?: Api.TrainingStatus;
  card?: boolean;
  type: Api.LearningType;
  eventRegistrationUrl?: string;
} & Omit<LabelProps, 'name'>;

const courseStatusToLabel: Record<Api.TrainingStatus | 'default', CourseCardLabelLinks> = {
  COMPLETED: CourseCardLabelLinks.TAKE_AGAIN,
  IN_PROGRESS: CourseCardLabelLinks.CONTINUE_LEARNING,
  OVERDUE: CourseCardLabelLinks.CONTINUE_LEARNING,
  NOT_STARTED: CourseCardLabelLinks.START_LEARNING,
  default: CourseCardLabelLinks.START_LEARNING,
};

const LearningDetailsLabel: React.FC<LearningDetailsLabelProps> = ({
  status,
  type,
  card,
  eventRegistrationUrl,
  ...rest
}) => {
  const role = useRole();

  const getLabelKey = (): string => {
    if (card) {
      if (type === Api.LearningType.Event) {
        return role === Role.LEARNER ? CourseCardLabelLinks.JOIN_EVENT : CourseCardLabelLinks.EVENT_DETAILS;
      }

      if (type === Api.LearningType.Document) {
        return CourseCardLabelLinks.DOCUMENT_DETAILS;
      }

      if (type === Api.LearningType.Video) {
        return CourseCardLabelLinks.VIDEO_DETAILS;
      }

      if (role === Role.GUEST) {
        return CourseCardLabelLinks.PREVIEW_COURSE;
      }

      if (role === Role.LEARNER_MANAGER) {
        return CourseCardLabelLinks.COURSE_DETAILS;
      }

      return status ? courseStatusToLabel[status] : courseStatusToLabel.default;
    }

    return TRAINING_VIEW_LABELS.BUTTON(type, role !== Role.GUEST || !!eventRegistrationUrl) || '';
  };

  return <Label name={getLabelKey()} {...rest} />;
};

export default LearningDetailsLabel;
